import React from "react";
// import { ChevronDown } from "lucide-react";
import logo from "assets/images/logo.svg";
import { Link } from "react-router-dom";
// import { MENU_ROOT } from "utils/menu.config";
// import { cn } from "utils/cn";
// import {
//   DropdownMenu,
//   DropdownMenuContent,
//   DropdownMenuItem,
//   DropdownMenuTrigger,
// } from "components/atoms";

function HeaderLogoBase() {
  // const { pathname } = useLocation();
  // const [selectedMenuItem, setSelectedMenuItem] = useState(MENU_ROOT[1]);

  // useEffect(() => {
  //   MENU_ROOT.forEach((item) => {
  //     if (item.rootPath && pathname.includes(item.rootPath)) {
  //       setSelectedMenuItem(item);
  //     }
  //   });
  // }, [pathname]);

  return (
    <div className="flex justify-center items-center gap-2 lg:gap-5 2xl:-ms-[60px]">
      {/* Logo Section */}
      <Link to="/" className="shrink-0 size-[42px]">
          <img src={logo} className="img-cover" alt="logo" />
      </Link>

      {/* Menu Section */}
      <div className="flex items-center gap-3">
        <h3 className="font-medium text-mono text-[16px]">
          BigfootMail LLC
          {/* Bigfoot Team */}
        </h3>
        {/* <span className="text-sm text-muted-foreground font-medium hidden md:inline">
          /
        </span> */}

        {/* <DropdownMenu>
          <DropdownMenuTrigger className="cursor-pointer outline-transparent text-mono font-medium flex items-center gap-2">
            {selectedMenuItem.title}
            <ChevronDown className="size-4 text-muted-foreground" />
          </DropdownMenuTrigger>
          <DropdownMenuContent sideOffset={10} side="bottom" align="start">
            {MENU_ROOT.map((item, index) => (
              <DropdownMenuItem
                key={index}
                asChild
                className={cn(item === selectedMenuItem && "bg-accent")}
              >
                <Link to={item.path || ""}>
                  {item.icon && <item.icon />}
                  {item.title}
                </Link>
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu> */}
      </div>
    </div>
  );
}

export const HeaderLogo = React.memo(HeaderLogoBase);
